import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { inject, bind } from '../../../utils/decorators';
import { BpsReferenzkraftKalibrierungStore, IBpsReferenzkraftDrehzahlSchlupfRollensatz } from '../../../stores/BpsReferenzkraftKalibrierungStore';
import { Panel, Table, FormControl, InputGroup } from 'react-bootstrap';

@observer
class BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit extends React.Component<{ ziel: IBpsReferenzkraftDrehzahlSchlupfRollensatz; index: number }, {}> {
  @inject(BpsReferenzkraftKalibrierungStore) store: BpsReferenzkraftKalibrierungStore;
  @bind @action handleValueChanged(ev: React.FormEvent<FormControl>) {
    this.props.ziel.geschwindigkeit[this.props.index] = (ev.target as HTMLInputElement).value !== '' ? (ev.target as HTMLInputElement).valueAsNumber : undefined;
  }
  @computed get imToleranzbereich() {
    const { drehzahlschlupf } = this.store.datensatz;
    const geschwindigkeit = this.props.ziel.geschwindigkeit[this.props.index];
    return (geschwindigkeit && (geschwindigkeit >= drehzahlschlupf.mingeschwindigkeit));
  }
  render() {
    const { geschwindigkeit } = this.props.ziel;
    return (
      <InputGroup>
        <FormControl
          type="number"
          step="0.1"
          readOnly={this.store.readOnly}
          value={(geschwindigkeit[this.props.index] !== undefined && geschwindigkeit[this.props.index] !== null) ? geschwindigkeit[this.props.index] : ''}
          onChange={this.handleValueChanged}
          className={this.imToleranzbereich === true ? 'text-success' : 'text-danger'}
        />
        <InputGroup.Addon>km/h</InputGroup.Addon>
      </InputGroup>
    );
  }
}

@observer
class BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf extends React.Component<{ ziel: IBpsReferenzkraftDrehzahlSchlupfRollensatz }, {}> {
  @inject(BpsReferenzkraftKalibrierungStore) store: BpsReferenzkraftKalibrierungStore;
  @bind @action handleValueChanged(ev: React.FormEvent<FormControl>) {
    this.props.ziel.schlupf = (ev.target as HTMLInputElement).value !== '' ? (ev.target as HTMLInputElement).valueAsNumber : null;
  }
  @computed get imToleranzbereich() {
    const { drehzahlschlupf } = this.store.datensatz;
    const { schlupf } = this.props.ziel;
    return (schlupf && (schlupf <= drehzahlschlupf.maxschlupf));
  }
  render() {
    const { schlupf } = this.props.ziel;
    return (
      <InputGroup>
        <FormControl
          type="number"
          step="0.1"
          readOnly={this.store.readOnly}
          value={schlupf !== null ? schlupf : ''}
          onChange={this.handleValueChanged}
          className={this.imToleranzbereich === true ? 'text-success' : 'text-danger'}
        />
        <InputGroup.Addon>%</InputGroup.Addon>
      </InputGroup>
    );
  }
}

/**
 * Exportierte Komponente für Eingabe und Validierung Rollendrehzahl und Abschaltschlupf
 */
@observer
export default class BpsReferenzkraftDrehzahlSchlupf extends React.Component<{}, {}> {

  @inject(BpsReferenzkraftKalibrierungStore) store: BpsReferenzkraftKalibrierungStore;

  render() {
    const { drehzahlschlupf } = this.store.datensatz;
    return (
      <Panel header="Rollendrehzahl und Abschaltschlupf" collapsible={true} defaultExpanded={true}>
        <Table striped={false} bordered={false} condensed={true} hover={false} className="bps-drehzahl-schlupf">
          <thead>
            <tr>
                <th/>
                <th>Rolle links</th>
                <th>Rolle rechts</th>
                <th/>
            </tr>
          </thead>
          <tbody>
            {/* Geschwindigkeit */}
            {[drehzahlschlupf.links, drehzahlschlupf.rechts].map((rs, key) =>
              <tr key={key}>
                <td className="beschriftung">Geschw. {key === 0 ? 'vor' : 'nach'} Abbrems.</td>
                {[0, 1].map(index =>
                    <td className="messwert" key={index}>
                      <BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit key={`${key}${index}`} ziel={rs} index={index}/>
                    </td>
                )}
                <td>&ge; {drehzahlschlupf.mingeschwindigkeit} km/h </td>
              </tr>
            )}
            {/* Schlupf */}
            <tr>
              <td className="beschriftung">Abschaltschlupf</td>
              {[drehzahlschlupf.links, drehzahlschlupf.rechts].map((rs, key) =>
                <td className="messwert" key={key}>
                  <BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf key={key} ziel={rs}/>
                </td>
              )}
              <td>&le; {drehzahlschlupf.maxschlupf} %</td>
            </tr>
          </tbody>
        </Table>
      </Panel>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/BpsReferenzkraftDrehzahlSchlupf.tsx